export default __webpack_public_path__ + "static/media/cluster.4e82a556.png";